import StubPage from "./StubPage";
import { GraduationCap, Sparkles, Award, Globe2 } from "lucide-react";
export default function Scholarships() {
  return <StubPage eyebrow="Scholarships" title="Federation Scholarship Programmes"
    subtitle="Financial support for athletes who excel on the mat — irrespective of background."
    sections={[
      { icon: Sparkles, title: "EWS Support", body: "Targeted scholarship for athletes from economically weaker sections with full federation membership coverage." },
      { icon: Award, title: "Medalist Scholarship", body: "Cash awards and stipends for national and international medallists in all three disciplines." },
      { icon: GraduationCap, title: "Youth Scholarship", body: "Under-18 talent development scholarship covering training, equipment and travel." },
      { icon: Globe2, title: "Development Scholarship", body: "Support for athletes selected to the federation's high-performance development squad." },
    ]}
  />;
}
